import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9aa56e58"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "websiteAddedModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "websiteAddedModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title text-white" }, "Added", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close btn-close-white",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "text-dark"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "text-dark"
}
const _hoisted_12 = {
  key: 2,
  class: "text-dark"
}
const _hoisted_13 = {
  key: 3,
  class: "text-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.addedWebsite.type === 'HEALTHCHECK')
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                _createTextVNode(" We will inform you immediately if this url has not been triggered at least once a day with a get/put/post request: "),
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("i", null, _toDisplayString(_ctx.healthCheckUrl), 1)
              ]))
            : (_ctx.addedWebsite.type === 'SSL')
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, " We will now inform you about SSL expiry on your domain from tomorrow morning onwards. "))
              : (_ctx.addedWebsite.type === 'SUBDOMAIN')
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, " We will now inform you about subdomain changes on your domain from tomorrow morning onwards. "))
                : (_openBlock(), _createElementBlock("p", _hoisted_13, " We will now inform you about text changes on your website from tomorrow morning onwards. "))
        ])
      ])
    ])
  ]))
}